<template>
  <div class="shadow-md flex flex-col justify-center items-center rounded-2xl bg-white py-6">
      <div class="flex items-center justify-start w-full px-5">
        <span class="text-start text-yank text-sm cursor-pointer">Folder Name</span>
      </div>
    <form class="flex flex-col items-center justify-center mt-2 px-5 w-full" @submit.prevent="submit" >
        <input type="text" name="folder_name" id="folder_name" v-model="folderName" class="form-input mb-3">
        <div class="flex w-full">
            <button @click="closeModal" class="w-1/2 py-2 text-sm border-payneHot border-2 rounded-lg mr-2" type="button">Cancel</button>
            <button class="w-1/2 py-2 text-sm bg-aquamarine rounded-lg text-white" type="submit">Create</button> 
        </div>
    </form>
</div>
</template>

<script>

export default {
    name:"CreateFolderModal",

    data(){
        return{
            folderName: '',
        }
    },

    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
        submit(){
            this.$emit('submit', this.folderName);
            this.folderName = '';
            this.closeModal();
        },
    },
}
</script>